import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.25),
  '& .CV2Text': {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 500,
    lineHeight: '150%',
  },
  '& .CV2CountContainer': {
    padding: theme.spacing(1.25, 2),
    backgroundColor: theme.palette.divider[4],
    borderRadius: 4,
    height: theme.typography.pxToRem(30),
    width: theme.typography.pxToRem(40),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '& .CV2Btn': {
    border: '1px solid',
    borderColor: theme.palette.divider[4],
    borderRadius: '50%',
    padding: theme.spacing(1.25),
    backgroundColor: theme.palette.secondary.main,
  },
}));

export default StyledBox;
